import { render, staticRenderFns } from "./SalesHeader.vue?vue&type=template&id=08d35b4e&"
import script from "./SalesHeader.vue?vue&type=script&lang=js&"
export * from "./SalesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports